// src/Legend.js
import React from 'react';

const defaultContainer = {
  position: 'absolute',
  bottom: 20,
  left: 10,
  zIndex: 1000,
  padding: '6px',
  background: 'rgba(255,255,255,0.9)',
  border: '1px solid #ccc',
  borderRadius: 4,
  fontSize: '11px',
  lineHeight: 1.2,
};

export default function Legend({
  // if url is provided, shows an image; otherwise shows inline items
  url = null,
  title = 'Legend',
  items = [],
  columns = 1,
  style = {},        // override container positioning
  imgStyle = {},     // if using url→image
}) {
  // for inline items: use a CSS grid with `columns` columns
  const listStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gap: '4px',
  };

  return (
    <div style={{ ...defaultContainer, ...style }}>
      <strong style={{ display: 'block', marginBottom: '4px' }}>
        {title}
      </strong>

      {url
        ? <img src={url} alt="Legend" style={{ display: 'block', maxWidth: '100%', ...imgStyle }} />
        : <ul style={listStyle}>
            {items.map(item => (
              <li key={item.label} style={{ display: 'flex', alignItems: 'center' }}>
                <span
                  style={{
                    display: 'inline-block',
                    width: '12px',
                    height: '12px',
                    background: item.color,
                    border: '1px solid #444',
                    marginRight: '6px'
                  }}
                />
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
      }
    </div>
  );
}




